import React from 'react'
import ProductsHoodies from './ProductsHoodies'

export default function Hoodies() {
  return (
    <div>
        <ProductsHoodies/>
    </div>
  )
}
